var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataElementProvide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41177 28.1592C5.35593 28.1592 4.5 29.0151 4.5 30.071V34.8927C4.50416 39.0926 7.90834 42.4963 12.1083 42.5004H36.6736C40.8736 42.4963 44.2773 39.0921 44.2814 34.8922V30.071C44.2814 29.0151 43.4255 28.1592 42.3697 28.1592C41.3138 28.1592 40.4579 29.0151 40.4579 30.071V34.8913C40.4544 36.9804 38.7613 38.6732 36.6723 38.6769L12.1085 38.6769C10.0197 38.6732 8.32721 36.9807 8.32355 34.8918V30.071C8.32355 29.0151 7.46762 28.1592 6.41177 28.1592Z",
    fill: "#A614B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2817 33.6896C25.3375 33.6896 26.1934 32.8337 26.1934 31.7779V12.0201L30.987 16.8137C31.7339 17.5606 32.9448 17.5606 33.6917 16.8137C34.4386 16.0668 34.4386 14.8558 33.6917 14.1089L25.6376 6.05473L25.6351 6.05226C25.5445 5.96294 25.4452 5.88289 25.3388 5.81328L25.3201 5.8011L25.1947 5.73401L25.0031 5.63823L24.8206 5.58348L24.818 5.58271L24.6765 5.54108L24.6544 5.5367C24.4083 5.48777 24.155 5.48777 23.9089 5.5367L23.8868 5.54108L23.7453 5.58271L23.7427 5.58348L23.5602 5.63823L23.3803 5.72797L23.2432 5.8011L23.2246 5.81328C23.1181 5.88289 23.0188 5.96294 22.9282 6.05226L22.9257 6.05473L14.8765 14.104L14.8618 14.1217C14.2329 14.8784 14.2811 15.9888 14.9731 16.6882C15.6651 17.3876 16.7749 17.4476 17.5382 16.8269L17.5582 16.8106L22.3699 11.9989V31.7779C22.3699 32.8337 23.2258 33.6896 24.2817 33.6896Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataElementProvide);
export default __webpack_public_path__ + "static/media/data-element-provide.02e9250f80523957818c02cfd99cc707.svg";
export { ForwardRef as ReactComponent };